import { Pipe, PipeTransform } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { prefixes, suffixes } from '@app/shared/utils';

@Pipe({
  name: 'userName',
})
export class UserNamePipe implements PipeTransform {
  private titleCasePipe = new TitleCasePipe();
  prefixes = prefixes;
  suffixes = suffixes;

  constructor() {}
  transform(user: any, possessive: boolean = false): string {
    let name = (user?.name ? [user?.name] : [user?.first_name ?? user?.user_first_name, user?.last_name ?? user?.user_last_name])
      .filter(Boolean)
      .join(' ');

    if (user?.prefix) {
      name = user?.prefix + ' ' + name;
    }

    name = this.titleCasePipe.transform(name);

    if (user?.suffix) {
      name = name + ' ' + user?.suffix;
    }

    name = name
      .split(' ')
      .map((word) => {
        const match =
          this.suffixes.find((suffix) => suffix.toLowerCase() === word.toLowerCase()) ||
          this.prefixes.find((prefix) => prefix.toLowerCase() === word.toLowerCase());
        return match ? match : word;
      })
      .join(' ');

    if (possessive && name) {
      const lastChar = name[name.length - 1];
      if (lastChar.toLowerCase() === 's') {
        name += `'`;
      } else {
        name += `'s`;
      }
    }

    return name;
  }
}
